export default "__VITE_ASSET__X1HmHC4g__"